import { httpDelete, httpGet, httpPatch, httpPost } from "@/src/api/http";
import type { DeleteRes, GetRes, PatchRes, PostRes, Req } from "@/src/api/types";

// Connectors come from pac-eventio (JSON Schemas per connector); connections are managed per
// environment. Option lookups fill the dropdowns of schema-driven forms.

export function listConnectors() {
    return httpGet<GetRes<"connectors/">>(`connectors/`);
}

export function listConnections() {
    return httpGet<GetRes<"connections/">>(`connections/`);
}

export function getConnection(connectionId: number) {
    return httpGet<GetRes<"connections/{connection_id}/">>(`connections/${connectionId}/`);
}

export function createConnection(body: Req<"connections/", "post">) {
    return httpPost<PostRes<"connections/">>(`connections/`, body);
}

export function updateConnection(connectionId: number, body: Req<"connections/{connection_id}/", "patch">) {
    return httpPatch<PatchRes<"connections/{connection_id}/">>(`connections/${connectionId}/`, body);
}

export function deleteConnection(connectionId: number) {
    return httpDelete<DeleteRes<"connections/{connection_id}/">>(`connections/${connectionId}/`);
}

export function testConnection(body: Req<"connections/test/", "post">) {
    return httpPost<PostRes<"connections/test/">>(`connections/test/`, body);
}

export function listConnectionOptions(
    connectionId: number,
    provider: string,
    params: Req<"connections/{connection_id}/options/{provider}/", "post">["params"],
) {
    return httpPost<PostRes<"connections/{connection_id}/options/{provider}/">>(
        `connections/${connectionId}/options/${provider}/`,
        { params },
    );
}
